module.exports = __webpack_public_path__ + "img/score_left.590df65f.png";